import configApp from '@/config'

/*
 | Los Droops que se administran en "Satélites": la clave con la que los nombra el backend, el sufijo
 | de sus endpoints (createSateliteJuedroop, readSatelitesRuleta…) y los límites que muestra su detalle,
 | en orden.
 |
 | Existe para que sumar un Droop sea sumar una entrada acá y sus textos en
 | m-edition-billing-satellites.js. Antes cada componente decidía con un "si no es Juedroop, es
 | Evaluación": con un tercer Droop no fallaba, se equivocaba, y el plan de Ruleta se creaba como uno
 | de Evaluaciones.
 |
 | 'habilitado' decide si aparece la pestaña. Los Droops que todavía no están terminados se esconden
 | con su flag de config (=== true, así un entorno sin la clave también los oculta).
 */
const DROOPS = {
  juedroop: {
    sufijo: 'Juedroop',
    habilitado: true,
    limites: [
      'maximo_juegos',
      'maximo_preguntas_por_juego',
      'maximo_jugadores_por_sala',
      'maximo_jugadores_por_sala_en_vivo',
      'modo_individual',
      'modo_en_vivo'
    ]
  },

  evaluacion: {
    sufijo: 'Evaluacion',
    habilitado: configApp.droopEvaluacionHabilitado === true,
    limites: [
      'maximo_evaluaciones',
      'maximo_preguntas_por_evaluacion',
      'modo_examen',
      'modo_practica',
      'modo_autoevaluacion',
      'resultados_analitica',
      'exportacion_csv'
    ]
  },

  ruleta: {
    sufijo: 'Ruleta',
    habilitado: configApp.droopRuletaHabilitado === true,
    limites: [
      'maximo_ruletas',
      'maximo_segmentos_por_ruleta',
      'modo_premios',
      'modo_preguntas',
      'enlace_publico',
      'exportacion_csv'
    ]
  }
}

/** Las claves de los Droops que se muestran, en orden. */
export function droopsHabilitados () {
  return Object.keys(DROOPS).filter(clave => DROOPS[clave].habilitado)
}

/** El sufijo de sus endpoints: 'Juedroop', 'Evaluacion', 'Ruleta'. */
export function sufijoDe (clave) {
  if (!DROOPS[clave]) {
    throw new Error(`Droop desconocido: ${clave}`)
  }

  return DROOPS[clave].sufijo
}

/** Los límites que muestra el detalle de un satélite de ese Droop, en orden. */
export function limitesDe (clave) {
  return DROOPS[clave] ? DROOPS[clave].limites : []
}
